module.exports = __webpack_public_path__ + "img/logo_color.de47e894.png";